import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../consts/table';
import { DEFAULT_FILTER } from '../admin/user';
import { Count } from '../../../models/count';

export function getTournamentPitches(
  user: AppUser,
  tournamentId: string,
  filter: any = DEFAULT_FILTER,
  search?: string
) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key },
    params: {
      filter,
      ...(search ? { search } : {})
    }
  };

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/pitches`, config)
    .then(response => {
      return response.data;
    });
}

export function getAllTournamentPitches(user: AppUser, tournamentId: string, where?) {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: {
            ...where
          },
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  } else {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          limit: DEFAULT_LIMIT,
          skip: DEFAULT_SKIP
        }
      }
    };
  }

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/pitches`, config)
    .then(response => {
      return response.data;
    });
}

export function getTournamentPitchesCount(
  user: AppUser,
  tournamentId: string,
  where?,
  search?: string
): Promise<Count> {
  const { roleSessionKey: key, activeSchoolId } = user;

  let config;

  if (typeof where !== 'undefined') {
    config = {
      headers: { usid: key },
      params: {
        filter: {
          where: where
        },
        ...(search ? { search } : {})
      }
    };
  } else {
    config = { headers: { usid: key }, params: search ? { search } : undefined };
  }

  return axios
    .get(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/pitches/count`, config)
    .then(response => {
      return response.data;
    });
}

export function createPitch(user: AppUser, tournamentId, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .post(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/pitches`, data, config)
    .then(response => {
      return response.data;
    });
}

export function updatePitch(user: AppUser, tournamentId: string, pitchId: string, data) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .put(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/pitches/${pitchId}`, data, config)
    .then(response => {
      return response.data;
    });
}

export function deletePitch(user: AppUser, tournamentId: string, pitchId: string) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .delete(`${window.apiBase}/i/schools/${activeSchoolId}/tournaments/${tournamentId}/pitches/${pitchId}`, config)
    .then(response => {
      return response.data;
    });
}
